import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { ListsIcon } from 'foundations-assets';
import UITruncateString from 'UIComponents/text/UITruncateString';
//@ts-expect-error no types for this lib
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AttainmentBarName = ({
  email,
  name,
  avatarSize
}) => email ? /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(UIAvatar, {
    hubSpotUserEmail: email,
    size: avatarSize,
    displayName: name || email,
    textSpacing: 1
  }), /*#__PURE__*/_jsx(UITruncateString, {
    className: "m-left-3",
    children: name || email
  })]
}) : /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(IconCircle, {
    backgroundColor: "fill-surface-raised",
    borderWidth: "0",
    color: "fill-tertiary-alt",
    icon: ListsIcon,
    size: "100"
  }), /*#__PURE__*/_jsx(UITruncateString, {
    className: "m-left-3",
    children: name
  })]
});